import mitt from "mitt";

export const fguTableEvents = mitt();
